/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ s: NonNullable<unknown> }} Supply_Air_FlowInputs */



/**
* | output |
* | --- |
* | "Supply flow: {s} m³/h" |
*
* @param {Supply_Air_FlowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const supply_air_flow = /** @type {((inputs: Supply_Air_FlowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supply_Air_FlowInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Supply flow: ${i?.s} m³/h`)
	return /** @type {LocalizedString} */ (`Débit soufflage: ${i?.s} m³/h`)
});